import { React } from 'react';

import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Snackbar from '@mui/material/Snackbar';

const statusMap = {
    danger: 'error',
    erro: 'error',
    failed: 'error',
    failure: 'error',
    ok: 'success',
    succes: 'success',
    warn: 'warning'
};

export const Alerta = (props) => {
    const handleClose = (event, reason) => {
        if (reason !== 'clickaway') {
            props.handleClose();
        }
    };

    const getStatus = () => {
        const rawStatus = String(props.status || '').trim().toLowerCase();

        if (rawStatus === '') {
            return 'warning';
        }

        return statusMap[rawStatus] || rawStatus;
    };
    const severity = getStatus();
    const safeSeverity = ['success', 'warning', 'error', 'info'].includes(severity) ? severity : 'info';

    return (
        <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={props.open}
            onClose={handleClose}
            sx={{
                top: { xs: 76, sm: 96 },
                zIndex: 1600,
                width: { xs: 'calc(100% - 24px)', sm: 'auto' }
            }}
        >
            <Alert
                className={`setta-alert-root setta-alert-${safeSeverity}`}
                variant='filled'
                severity={safeSeverity}
                onClose={handleClose}
                sx={{
                    alignItems: 'flex-start',
                    width: { xs: '100%', sm: 'min(560px, calc(100vw - 48px))' },
                    maxHeight: '50vh',
                    borderRadius: '18px',
                    fontFamily: 'var(--app-font-body)',
                    fontWeight: 800,
                    letterSpacing: 0,
                    backdropFilter: 'blur(18px)',
                    overflow: 'hidden',
                    '& .MuiAlert-icon': {
                        alignItems: 'flex-start',
                        opacity: 1
                    },
                    '& .MuiAlert-message': {
                        lineHeight: 1.45,
                        maxHeight: 'calc(50vh - 18px)',
                        minHeight: 0,
                        overflowY: 'auto',
                        overflowWrap: 'anywhere',
                        padding: '9px 0',
                        whiteSpace: 'pre-wrap'
                    },
                    '& .MuiAlert-action': {
                        alignItems: 'flex-start',
                        paddingTop: 0
                    }
                }}
            >
                {props.texto}
            </Alert>
        </Snackbar>
    );
};

export const PopupDialog = (props) => {
    function handleConfirmar (e) {
        e.preventDefault();
        props.funcao();
        props.handleClose();
    }

    return (
        <Dialog open={props.open} onClose={props.handleClose}>
            <DialogTitle>
                {props.titulo}
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {props.texto}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={(e) => { handleConfirmar(e); }}>Confirmar</Button>
                <Button onClick={props.handleClose}>Cancelar</Button>
            </DialogActions>
        </Dialog>
    );
};
